export default __webpack_public_path__ + "static/offerings1-1def5fa90113c8a031820351ec53f78c.jpg";